import { toRefs, computed } from 'vue';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';
import { convertToUnit } from '../../utils/component-lib.esm10.js';
import { setAlpha } from '../../styles/component-lib.esm2.js';
import { colors } from '../../styles/component-lib.esm.js';

//
const PaperProps = {
  component: {
    type: String,
    default: 'div'
  },
  color: {
    type: String,
    default: '#fff'
  },
  borderWidth: {
    type: [Number, String],
    default: 0
  },
  borderColor: {
    type: String,
    default: '#ebebeb'
  },
  elevation: {
    type: Number,
    default: null
  },
  elevateOnHover: Boolean,
  hideStaticShadow: Boolean
};
function standardShadow(props) {
  const e = props.elevation;
  let offsetX = 1;
  let offsetY = 2;
  let blurRadius = 1.5 * e + 4;
  let spreadRadius = 1.5 * e + 1;
  let color = setAlpha(colors.black, e * 0.05 + 0.05);
  return `${offsetX}px ${offsetY}px ${blurRadius}px ${spreadRadius}px
      ${color}`;
}
function hoverShadow(props) {
  const e = props.elevation;
  let offsetX = 0;
  let offsetY = 5;
  let blurRadius = 2 * e + 15;
  let spreadRadius = 3 * e - 2;
  let color = setAlpha(colors.black, e * 0.08 + 0.1);
  return `${offsetX}px ${offsetY}px ${blurRadius}px ${spreadRadius}px ${color}`;
}
var script = {
  name: 'Paper',
  props: PaperProps,
  setup(props) {
    const {
      color,
      borderColor,
      hideStaticShadow,
      elevateOnHover
    } = toRefs(props);
    const theme = useTheme();
    const styles = computed(() => {
      let elevateHoverShadow = elevateOnHover.value && hoverShadow(props);
      if (hideStaticShadow.value && elevateOnHover.value) elevateHoverShadow = standardShadow(props);
      return {
        '--c-color': getThemeColor(color.value, theme.value),
        '--c-border-width': convertToUnit(props.borderWidth),
        '--c-border-color': getThemeColor(borderColor.value, theme.value),
        '--c-shadow': hideStaticShadow.value ? 'none' : standardShadow(props),
        '--c-shadow-hover': elevateHoverShadow
      };
    });
    return {
      styles
    };
  }
};
export { PaperProps, script as default };